export default __webpack_public_path__ + "static/media/img01.1c9f1e13.jpg";